import { ISessionDestroyLocalStorageRepository } from '@modules/sessions/repositories/localStorage/implementations/ISession';

export class SessionDestroyLocalStorageRepository
  implements ISessionDestroyLocalStorageRepository
{
  public execute(): void {
    localStorage.clear();
  }
}
